import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";

import { createBoxes } from "../../../../helpers";
import Analytics from "../../../../helpers/analytics";
import RecommendedContainer from "./Commerce/styles/Recommended.style";

const Recommended = (props) => {
  const {
    user,
    auth,
    addFavorite,
    removeFavorite,
    addToCart,
    removeFromCart,
    recommended,
    isMobile
  } = props;

  const [visible, setVisible] = useState(8);

  const onClickShowMore = () => {
    Analytics.track("RecommendedVideos", {
      category: "LP-VideoDetail",
      label: "ShowMoreVideos"
    });

    setVisible(() => 16);
  };

  const onClickRecommendedVideos = () => {
    Analytics.track("RecommendedVideos", {
      category: "LP-VideoDetail",
      label: "RecommendedVideosVideoDetail"
    });
  };

  return (
    <RecommendedContainer className="recommendations">
      <h3 className="header__text">Recommended</h3>

      <div onClick={onClickRecommendedVideos} className="recommended__wrapper">
        {createBoxes(
          {
            videos: recommended.slice(0, visible).map((it) => it),
            user: user,
            auth: auth,
            methods: {
              addFavorite: addFavorite,
              removeFavorite: removeFavorite,
              addToCart: addToCart,
              removeFromCart: removeFromCart
            }
          },
          "video-detail-recommendations"
        )}
      </div>

      {recommended.length > 8 && visible !== 16 && (
        <Button variant="outlined" className="view__more" onClick={onClickShowMore}>
          View More {!isMobile && "recommended"}
        </Button>
      )}
    </RecommendedContainer>
  );
};

Recommended.propTypes = {
  user: PropTypes.shape().isRequired,
  auth: PropTypes.shape().isRequired,
  addFavorite: PropTypes.func.isRequired,
  removeFavorite: PropTypes.func.isRequired,
  addToCart: PropTypes.func.isRequired,
  removeFromCart: PropTypes.func.isRequired,
  recommended: PropTypes.array.isRequired
};

export default Recommended;
